import React from 'react';
import { Link } from 'react-router-dom';
import './AuthPages.css';

const Icon = ({ name }) => {
  const paths = {
    shield: <><path d="M12 3 4 6v5c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6Z"/><path d="m9 12 2 2 4-5"/></>,
    users: <><circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2"/><path d="M3 19c0-4 2-6 6-6s6 2 6 6M15 14c3 0 5 2 5 5"/></>,
    mountain: <><path d="m3 19 6-11 3 5 2-3 7 9Z"/><path d="m7 12 2 2 2-2"/></>,
  };
  return <svg className="ui-icon" viewBox="0 0 24 24" aria-hidden="true">{paths[name]}</svg>;
};

function AuthPageLayout({ eyebrow, title, description, mode, children }) {
  return (
    <div className={`auth-page auth-page-${mode}`}>
      <section className="auth-story" aria-label="About ClimberLink">
        <div className="auth-story-shade" />
        <div className="auth-story-top">
          <Link to="/" className="auth-wordmark">Climber<span>Link</span></Link>
          <span>THE PROFESSIONAL CLIMBING NETWORK</span>
        </div>
        <div className="auth-story-copy">
          <span className="auth-kicker">BUILT FOR THE NEXT OBJECTIVE</span>
          <h2>Your climbing life.<br />One trusted network.</h2>
          <p>Connect with the right partners, document your experience, and plan expeditions with greater confidence.</p>
          <div className="auth-benefits">
            <div><Icon name="users" /><span><strong>Find your rope team</strong><small>Connect by skills, location, and objectives.</small></span></div>
            <div><Icon name="mountain" /><span><strong>Build your climbing résumé</strong><small>Keep summits, training, and highlights together.</small></span></div>
            <div><Icon name="shield" /><span><strong>Climb with context</strong><small>See experience before committing to a team.</small></span></div>
          </div>
        </div>
        <div className="auth-story-footer"><span>CLIMBERLINK</span><span>PLAN WELL · CLIMB STRONG · COME HOME</span></div>
      </section>

      <section className="auth-form-side">
        <div className="auth-form-shell">
          <div className="auth-form-heading">
            <span className="eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          {children}
        </div>
      </section>
    </div>
  );
}

export default AuthPageLayout;
